import {persistReducer} from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';

export const createPersistedReducer = ({
  key,
  whitelist,
  blacklist,
  reducer,
}) =>
  persistReducer(
    {
      key,
      storage: storage,
      whitelist,
      blacklist,
      stateReconciler: autoMergeLevel2,
    },
    reducer,
  );
